import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useQuery } from './useQuery';
import getMylistQuery from '../queries/mylist/getMylistQuery';

const useMylist = ({
  customerAccountID, userId, customerType = 'B2C', lazy = false, skip = false
}) => {
  const options = {
    ssr: false,
    skip: skip || (!userId && !customerAccountID),
    lazy,
    errorPolicy: 'all',
    variables: {
      customerAccountID,
      userId,
      customerType
    }
  };
  const Query = getMylistQuery();

  if (lazy) return useLazyQuery(Query, options);

  const resp = useQuery(Query, options);

  return resp;
};

export default useMylist;
